import { render, staticRenderFns } from "./VIPCard.vue?vue&type=template&id=4a4cc5c4&"
import script from "./VIPCard.vue?vue&type=script&lang=js&"
export * from "./VIPCard.vue?vue&type=script&lang=js&"
import style0 from "./VIPCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports